import React, { useEffect, useState } from 'react';
import { UsersIcon } from 'lucide-react';
export function LiveVisitorCounter() {
  const [visitors, setVisitors] = useState(124);
  useEffect(() => {
    const interval = setInterval(() => {
      setVisitors(prev => {
        const change = Math.floor(Math.random() * 5) - 2; // -2 to +2
        return Math.max(80, Math.min(250, prev + change));
      });
    }, 3000);
    return () => clearInterval(interval);
  }, []);
  return <div className="flex items-center gap-1.5 sm:gap-2 text-xs sm:text-sm text-orange-800/80 bg-white/80 backdrop-blur-sm px-2.5 sm:px-3 py-1.5 rounded-full shadow-sm border border-orange-100 max-w-full" data-id="element-178">
      <div className="relative flex-shrink-0" data-id="element-179">
        <div className="absolute inset-0 bg-green-400 rounded-full animate-ping opacity-75" data-id="element-180"></div>
        <div className="relative w-2 h-2 bg-green-500 rounded-full" data-id="element-181"></div>
      </div>
      <span className="font-medium whitespace-nowrap" data-id="element-182">{visitors} personas</span>
      <span className="hidden sm:inline whitespace-nowrap" data-id="element-183">
        viendo esta página
      </span>
    </div>;
}